export default {
      id: "ic_like-usage",
      viewBox: "0 0 40 40",
      url: "/" + "images/icons.3.109.2.svg#ic_like-usage",
      toString: function () {
        return this.url;
      }
    }